import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { storage } from '../utils/storage';
import './ChangePinModal.css';

function PinVerifyModal({ onVerified, onClose }) {
  const { t } = useTranslation();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const handleNumberClick = (num) => {
    if (error) setError('');
    if (shake) setShake(false);
    if (pin.length >= 6) return;
    setPin(pin + num);
  };

  const handleBackspace = () => {
    if (error) setError('');
    if (shake) setShake(false);
    setPin(pin.slice(0, -1));
  };

  const handleSubmit = () => {
    if (pin.length < 4) return;
    const savedPin = storage.get('admin_screen_pin');
    if (pin === savedPin) {
      onVerified();
    } else {
      setError(t('lock.incorrectPin'));
      setShake(true);
      setTimeout(() => {
        setPin('');
        setShake(false);
      }, 1000);
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div
        className="change-pin-modal"
        role="dialog"
        aria-modal="true"
        aria-label={t('fiscal.pinRequired')}
      >
        <div className="modal-header">
          <h2>{t('fiscal.pinRequired')}</h2>
          <button type="button" className="modal-close-btn" onClick={onClose}>
            <Icon name="close" size="small" />
          </button>
        </div>

        <div className="modal-body">
          <p className="pin-title">{t('fiscal.pinVerifyPrompt')}</p>

          {error && (
            <div className="pin-error" role="alert">
              {error}
            </div>
          )}

          <div className={`pin-dots ${shake ? 'shake' : ''}`}>
            {[0, 1, 2, 3, 4, 5].map((index) => (
              <div
                key={index}
                className={`pin-dot ${pin.length > index ? 'filled' : ''} ${index >= 4 ? 'optional' : ''}`}
              />
            ))}
          </div>

          <div className="pin-keypad">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
              <button
                type="button"
                key={num}
                className="pin-button"
                onClick={() => handleNumberClick(num.toString())}
              >
                {num}
              </button>
            ))}
            <button type="button" className="pin-button empty" disabled></button>
            <button type="button" className="pin-button" onClick={() => handleNumberClick('0')}>
              0
            </button>
            <button type="button" className="pin-button backspace" onClick={handleBackspace}>
              <Icon name="backspace" size="small" />
            </button>
          </div>

          <button
            type="button"
            className="btn btn-primary pin-submit-btn"
            onClick={handleSubmit}
            disabled={pin.length < 4}
          >
            {t('lock.unlock')}
          </button>
        </div>
      </div>
    </>
  );
}

export default PinVerifyModal;
